import { render, staticRenderFns } from "./Vaccinations.vue?vue&type=template&id=d2061338"
import script from "./Vaccinations.vue?vue&type=script&lang=js"
export * from "./Vaccinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports